var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgX = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 511.999 511.999"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 349",
  d: "M302.413 256L502.378 56.034a32.819 32.819 0 10-46.412-46.413L256 209.587 56.034 9.622A32.818 32.818 0 109.621 56.033L209.585 256 9.62 455.965a32.819 32.819 0 1046.413 46.413L256 302.411l199.963 199.965a32.82 32.82 0 1046.413-46.414z",
  fill: "#ed6c7b"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 350",
  d: "M302.413 256L502.378 56.034a32.819 32.819 0 10-46.412-46.413L256 209.586v92.828l199.965 199.965a32.82 32.82 0 1046.413-46.414z",
  fill: "#d65b72"
})));
export default SvgX;